import script from "./Pagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=ts"

import "./Pagination.vue?vue&type=style&index=0&id=577f56db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-577f56db"]])

export default __exports__